import styled, { css } from "styled-components/native";
import { dark_gray, spacing_l } from "../../StyleHelpers";
import { HeroProps, StyledProps } from "./model";

//Hero Banner Style
export const StyledHeroContainer = styled.View<HeroProps>`
	padding: ${(props) => (props.heroBanner ? spacing_l : 0)} 0 0 0;
`;

export const StyledMain = styled.View`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const FeatureText = styled.View<any>`
	background-image: ${(props) => (props.isNoBgColor ? "transparent" : "linear-gradient(90deg, #131313 0%, rgba(19, 19, 19, 0) 100%)")};
	position: absolute;
	display: flex;
	border-radius: 16px;
	justify-content: center;
	flex-direction: column;

	${(props) =>
		!props.isNarrow &&
		css`
			gap: 1.5rem;
			top: 0px;
			left: 153px;
			padding: 5vh 5vw;
			max-width: 45%;
			height: 99.5%;
			z-index: 100;
			margin: 1px 1px 1px 1px;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			top: 1px;
			left: 1px;
			width: 50%;
			height: calc(100% - 2px);
			aspect-ratio: ${4 / 1};
			padding: 2.5rem;
			align-items: flex-start;
			gap: 1.5rem;
			flex-shrink: 0;
			border-color: transparent;
			z-index: 9;
		`}
`;

export const FeatureLineOne = styled.Text<any>`
	font-size: ${(props) => props?.fontSize};
	font-weight: 500;
	font-style: normal;
	line-height: ${(props) => props?.lineHeight};
	color: ${(props) => props?.hexCode};
	text-overflow: ellipsis;
`;

export const FeatureLineTwo = styled.Text<any>`
	font-size: ${(props) => props?.fontSize};
	font-weight: 500;
	font-style: normal;
	line-height: ${(props) => props?.lineHeight};
	color: ${(props) => props?.hexCode};
`;

export const TextContainer = styled.View<any>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1.5rem;
	align-self: stretch;
`;

//Footer Banner Style
export const StyledFooterContainer = styled.View<StyledProps>`
	background-color: ${dark_gray};
	${(props) =>
		props.banner &&
		css`
			background-image: url(${props.banner});
			background-repeat: no-repeat;
			background-size: cover;
		`}

	border-radius: 1rem;
	height: auto;
	aspect-ratio: ${4 / 1};
	width: ${(props) => props.width};
	border-width: 2px;
	margin-top: 32px;
	margin-left: 12px;
	outline-color: rgba(255, 255, 255, 0.3);
	outline-style: solid;
	outline-width: 2px;
	outline-offset: -2px;
	background-color: ${dark_gray};
`;

export const FeatureTextFooter = styled.View<any>`
	top: 1px;
	left: 1px;
	display: flex;
	width: 50%;
	height: 100%;
	padding: 2.5rem;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 1.5rem;
	flex-shrink: 0;
	border-radius: 16px;
	border-color: transparent;
	background-image: linear-gradient(90deg, #131313 0%, rgba(19, 19, 19, 0) 100%);
	z-index: 9;
`;

export const FeatureLineTwoFooter = styled.Text<any>`
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: ${(props) => props?.clamp};
	align-self: stretch;
	overflow: hidden;
	text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);
	font-family: "Nunito";
	font-size: ${(props) => props?.fontSize};
	font-weight: 500;
	font-style: normal;
	line-height: ${(props) => props?.lineHeight};
	color: #fff;
`;

export const TextContainerFooter = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1.5rem;
	align-self: stretch;
`;

export const StyledButton = styled.View`
	width: 368px;
`;

export const StyledFooterMain = styled.View<any>`
	width: 100%;
	align-items: ${(props) => (props?.isNarrow ? "center" : "flex-start")};
	margin-left: ${(props) => (props?.isNarrow ? 0 : "140px")};
`;

export const StyledLoaderContent = styled.View<any>`
	${(props) =>
		props.isShowLoader &&
		props.isNarrow &&
		css`
			margin-top: 80px;
		`}

	${(props) =>
		props.isShowLoader &&
		!props.isNarrow &&
		css`
			margin-top: 120px;
		`}
`;
